import React from "react";
import { useSelector } from "react-redux";
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import SearchPage from "../Pages/searchPage";

function Routing() {
    const appSettings = useSelector(({ rootReducer }) => rootReducer.baseSettings);
    const searchSlug = appSettings.searchSlug ? appSettings.searchSlug : '/';

    return (
      <Router>
        <Switch>
            <Route key="SearchPage" path={searchSlug} exact component={SearchPage} />
            <Redirect to={searchSlug} />
        </Switch>
      </Router>
    );
}

export default Routing;
